import { DynamicStandaloneTagsIndex } from '@/components/TagsIndex';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorTagsIndex: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneTagsIndex
      tags={data.tags}
      headline="Alla ämnen"
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorTagsIndex;
